module.exports = __webpack_public_path__ + "static/img/Baby Products.a39c3d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/Baby Products.jpg
// module id = 3Wc9
// module chunks = 1